import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0","key":"svg-0"}],["path",{"d":"M12 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0","key":"svg-1"}],["path",{"d":"M12 9h8.4","key":"svg-2"}],["path",{"d":"M14.598 13.5l-4.2 7.275","key":"svg-3"}],["path",{"d":"M9.402 13.5l-4.2 -7.275","key":"svg-4"}]]

const IconBrandChrome = createReactComponent('outline', 'brand-chrome', 'BrandChrome', __iconNode);

export default IconBrandChrome;